import z from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import {
  type AdvancePaymentStatus,
  AdvancePaymentStatusSchema,
  CompletedAdvancePaymentStatusSchema,
  OpenAdvancePaymentStatusSchema,
} from '../advance-payment.models.ts'
import { AdvancePaymentIdSchema, ProjectIdSchema } from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const AdvancePaymentStatusChangedActivityStatusSchema =
  AdvancePaymentStatusSchema.extract([
    ...OpenAdvancePaymentStatusSchema.extract(['submitted', 'approved'])
      .options,
    ...CompletedAdvancePaymentStatusSchema.options,
  ])

export type AdvancePaymentStatusChangedActivityStatus = ZodInfer<
  typeof AdvancePaymentStatusChangedActivityStatusSchema
>

export const isActivityAdvancePaymentStatus = (
  status: AdvancePaymentStatus
): status is AdvancePaymentStatusChangedActivityStatus => {
  return AdvancePaymentStatusChangedActivityStatusSchema.safeParse(status)
    .success
}

export const AdvancePaymentStatusChangedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'advance_payment_status_changed',
    z.object({
      projectId: ProjectIdSchema,
      advancePaymentId: AdvancePaymentIdSchema,
      status: AdvancePaymentStatusChangedActivityStatusSchema,
      ...ActivityLinkTargets('project'),
    })
  )
